import { render } from "./PaymentV2.vue?vue&type=template&id=442b728a"
import script from "./PaymentV2.vue?vue&type=script&lang=js"
export * from "./PaymentV2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__